// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dpTEenlLnYatXpekFtKxk","money":"_1x879xNDjsEOSYp-50yZE2"};